export const SEARCH_INTERVAL = 1_500;
export type Timer = ReturnType<typeof setTimeout> | null;
export type ColumnType = 'text' | 'boolean' | 'number' | 'date';
export type SearchRef = { clear: () => void } | null;

export type SearchAsyncColumnDef = {
  id: string;
  type: ColumnType;
};

export function clearTimerRef(timer: Timer) {
  if (timer) {
    clearTimeout(timer);
  }
}

export function getSearchAsParams({ value: _value, columns }: { value: string; columns: SearchAsyncColumnDef[] }) {
  // remove invalid regex expressions (i.e. "[[", "]]" for "refId")
  const value = _value.replaceAll('[[', '').replaceAll(']]', '');

  const searchDefs = columns.map(({ id, type }) => {
    if (type === 'boolean') {
      return { property: id, operator: 'includes', value };
    } else if (type === 'number') {
      return { property: id, operator: 'includes', value };
    } else if (type === 'date') {
      return null;
    } else {
      return { property: id, operator: 'includes', value };
    }
  });

  return searchDefs.filter((s) => s !== null);
}
